export default __webpack_public_path__ + "static/media/principles_long_term1.8ff37183.png";